/**
 * Descobre a codificação do CSV da campanha e devolve o texto já legível.
 *
 * CSV não guarda em lugar nenhum qual codificação usa, e errar aqui estraga
 * todo acento e emoji da mensagem que vai pro cliente — "gostaríamos" virava
 * "gostarÃ­amos" e o 🔴 virava "ð´".
 *
 * Os bytes crus entregues ao SheetJS faziam ele assumir Windows-1252 na
 * ausência de marca de ordem de bytes, e hoje quase tudo é gerado em UTF-8.
 * Mas forçar UTF-8 trocaria um problema pelo outro: o Excel em português ainda
 * salva CSV em Windows-1252 por padrão.
 *
 * Daí a tentativa em duas etapas: UTF-8 no modo estrito primeiro; se aparecer
 * um byte que não existe em UTF-8, o arquivo é Windows-1252 e a leitura
 * recomeça assim. Os dois passam sem perguntar nada a quem sobe a lista.
 */
export function lerTextoDoCsv(bytes: Uint8Array): string {
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return new TextDecoder('windows-1252').decode(bytes);
  }
}
